import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { NAVIGATION_MENU_ITEMS } from '@app/containers/models/navigation-menu-config';
import { APP_STORE } from '@core/stores/app.store';
import { ZendeskSupportToggleDirective } from '@zendesk/directives/zendesk-support-toggle.directive';
import { ZENDESK_STORE } from '@zendesk/stores/zendesk.store';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    RouterLink,
    RouterLinkActive,

    MatNavList,
    MatListItem,
    MatBadge,
    MatIcon,
    MatTooltip,

    ZendeskSupportToggleDirective
  ]
})
export class SidenavComponent {
  readonly #appStore = inject(APP_STORE);
  readonly #zendeskStore = inject(ZENDESK_STORE);

  readonly sidenavPinned = this.#appStore.sidenavPinned;

  readonly menuItems = NAVIGATION_MENU_ITEMS;

  readonly canShowSupport = this.#zendeskStore.canShowWidget;
  readonly isSupportOpen = this.#zendeskStore.isOpen;
  readonly supportUnreadCount = this.#zendeskStore.unreadCount;

  toggleSidenavPinned(): void {
    this.#appStore.toggleSidenavPinned();
  }
}
